var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.5 3.53125C18.9366 3.53125 23.3437 7.93845 23.3437 13.375C23.3437 15.6196 22.5925 17.6887 21.3277 19.3446L27.5531 25.5719C28.0656 26.0845 28.0656 26.9155 27.5531 27.4281C27.0799 27.9012 26.3354 27.9376 25.8206 27.5373L25.6969 27.4281L19.4696 21.2027C17.8137 22.4675 15.7446 23.2187 13.5 23.2187C8.06345 23.2187 3.65625 18.8116 3.65625 13.375C3.65625 7.93845 8.06345 3.53125 13.5 3.53125ZM13.5 6.15625C9.51319 6.15625 6.28125 9.38819 6.28125 13.375C6.28125 17.3618 9.51319 20.5937 13.5 20.5937C17.4868 20.5937 20.7187 17.3618 20.7187 13.375C20.7187 9.38819 17.4868 6.15625 13.5 6.15625Z","fill":"#fff"}));
}

Search.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Search;

Search.default = Search;
